export default __webpack_public_path__ + "static/media/required-approvals.5b6d0398.svg";